import React from 'react';
import LoginComp from '../../components/auth/LoginComp';

const Signin = () => {
  return (
    <div>
        <LoginComp />
    </div>
  )
}

export default Signin